import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, Form, reset, formValueSelector, change } from 'redux-form';
import Button from 'material-ui/Button';
import IconButton from 'material-ui/IconButton';
import { MenuItem } from 'material-ui/Menu';
import Paper from 'material-ui/Paper';
import Snackbar from 'material-ui/Snackbar';
import { SnackbarContent } from 'material-ui/Snackbar';
import { Error as ErrorIcon, Close as CloseIcon } from '@material-ui/icons';

import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import optional from '../../helpers/OptionalAccess';

import Layout from '../Layout';
import renderTextField from '../../helpers/RenderTextFiled';
import renderSelectField from '../../helpers/RenderSelectField';
import RenderDialog from '../../helpers/RenderDialog';
import validationHelper from '../../helpers/ValidationHelper';

import PostFrame from '../../components/PostFrame';
import { getAllCoverageScore, clearAllCoverageScore } from '../../actions/getAllCoverageScore';
import { getAutocheckVehicleHistory, clearAutocheckVehicleHistory } from '../../actions/getAutocheckVehicleHistory';
import { getPhysicalDamage, clearPhysicalDamage } from '../../actions/getPhysicalDamage';
import { getAutocheckNMVTISReport, clearAutocheckNMVTISReport } from '../../actions/getAutocheckNMVTISReport';
import { getRiskPredictorScore, clearRiskPredictorScore } from '../../actions/getRiskPredictorScore';
import { getAutocheckMileageReport, clearAutocheckMileageReport } from '../../actions/getMileageReport';
import searchByAttribute from '../../actions/searchByAttribute';
import getReportTypes from '../../actions/getReportTypes';
import { getACAReport, clearACAReport } from '../../actions/getACAReport';

import normalizeReferenceNumber from '../../helpers/NormalizeReferenceNumber';
import { ProductMap } from '../../helpers/ProductMap';

const styles = theme => ({
  card: {
    display: 'flex',
    boxShadow: 'none',
  },
  content: {
    display: 'flex',
  },
  paperStyle: {
    width: '70%',
    height: '70%',
    display: 'inline-block',
    margin: 20,
    marginTop: '13vh'
  },
  buttonStyle: {
    marginTop: 10,
    marginBottom: 15,
    textAlign: 'center',
    width: '22%',
    marginLeft: '45%',
    display: 'flex',
    justifyContent: 'space-between'
  },
  messageStyle: {
    paddingLeft: '15px',
    paddingTop: '10px'
  },
  '@media screen and (max-width: 1130px)': {
    buttonStyle: {
      flexWrap: 'wrap',
      textAlign: 'center'
    },
  },
  '@media screen and (max-width: 600px)': {
    buttonStyle: {
      width: '30%',
      marginLeft: '33%'
    },
  },
  buttonSize: {
    minWidth: 123,
    height: 36
  },
  marginStyle: {
    margin: 8
  },
  textField: {
    width: 200,
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  headerStyle: {
    position: 'relative',
    width: '100%',
    height: '60px',
    background: '#FFFFFF',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
    borderRadius: '10px',
  },
  headerTitleStyle: {
    flexDirection: 'column',
    margin: '2%',
    fontSize: '24px',
    fontFamily: 'Roboto'
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  alertClass: {
    border: '1px solid',
    borderColor: 'red',
    borderRadius: '10px',
  },
  centerMsg: {
    textAlign: 'center',
    color: 'red',
  },
  snackbarContent: {
    backgroundColor: theme.palette.error.dark,
    flexWrap: 'nowrap',
    borderRadius: 8,
  },
  snackbarMessage: {
    display: 'flex',
    alignItems: 'center',
  },
  snackbarIcon: {
    marginRight: theme.spacing.unit,
  },
  snackbarClose: {
    padding: theme.spacing.unit / 2,
  },
});

const validate = (values, props) => {
  const selectedProduct = sessionStorage.getItem('product');
  const locationId = localStorage.getItem('locationId');
  const location = props.data.person.locations.find(l => l.locationId === locationId);
  const { customerId } = location;
  const { selectReport } = props;

  let errors = validationHelper.validateRequired(['VIN', 'selectReport', 'scoreModel'], values);
  if (selectedProduct === 'AutoCheck Insurance' && (props.data.config.progressiveCustomerId.includes(customerId) || props.data.config.ssoTestCustomer.includes(customerId)) && (selectReport && (selectReport === 'VEHICLE_HISTORY' || selectReport === 'RISK_PLUS'))) {
    errors = validationHelper.validateRequired(['VIN', 'selectReport', 'scoreModel', 'referenceNumber'], values);
    if (values.referenceNumber && !validationHelper.validateReferenceNumber(values.referenceNumber)) {
      errors.referenceNumber = 'Reference number is invalid.';
    }
  }
  if (values.VIN && !validationHelper.validateVin(values.VIN)) {
    errors.VIN = 'VIN is invalid. Please check and try again';
  }

  if (values.VIN && !validationHelper.validateLengthRange(values.VIN, 17, 17)) {
    errors.VIN = 'VIN length should be 17';
  }

  const lengthValidation = [
    { field: 'referenceNumber', label: 'Reference Number', value: values.referenceNumber, min: 0, max: 50 }
  ];

  validationHelper.validateLength(errors, lengthValidation);

  return errors;
};

const upper = value => value && value.trim().toUpperCase();
let selectedProduct = '';
const experianHtmlReports = [
  'VEHICLE_HISTORY',
  'NMVTIS'
];

class RunReport extends Component {
  state = {
    open: false,
    custReportData: [],
    selectedReportType: '',
    submittedVIN: '',
    snackbarOpen: false,
    snackbarMessage: ''
  };

  componentDidMount() {
    this.props.actions.getReportTypes(this.props.data.config);
    this.props.actions.custReportData(this.props.data.config, this);
  }

  componentDidUpdate(prevProps) {
    const { nmvtisReport } = this.props.data;
    const prevNmvtisReport = prevProps.data.nmvtisReport;

    // Check if NMVTIS report finished fetching
    if (
      this.state.selectedReportType === 'NMVTIS' &&
      this.state.open &&
      prevNmvtisReport.fetching &&
      !nmvtisReport.fetching &&
      nmvtisReport.fetched
    ) {
      let hasNoRecords = !nmvtisReport.report || !nmvtisReport.report.autocheckResponse;

      if (!hasNoRecords && nmvtisReport.report.autocheckResponse) {
        try {
          const decodedResponse = atob(nmvtisReport.report.autocheckResponse);
          hasNoRecords = decodedResponse.includes('NMVTIS did not return any records');
        } catch (e) {
          console.error('Error decoding NMVTIS response:', e);
          hasNoRecords = true;
        }
      }

      if (hasNoRecords) {
        this.setState({
          snackbarOpen: true,
          snackbarMessage: `We are sorry, NMVTIS did not return any records for VIN ${this.state.submittedVIN}`
        });
        this.hideModal();
      }
    }
  }

  handleSave = (event) => {
    this.setState({ open: true, selectedReportType: event.selectReport, submittedVIN: event.VIN });
    const productMap = { 'AutoCheck Auctions': 'ACA', 'AutoCheck Insurance': 'ACI', 'VIN Cross Check': 'VXC' };
    // TODO: figure out how to not use absolute values here
    if (event.selectReport === 'VEHICLE_HISTORY' && sessionStorage.getItem('product') === 'AutoCheck Auctions') {
      // 1B7KF26D7VJ581950
      this.props.actions.getAutocheckVehicleHistory(event.VIN, null, event.selectReport, this.props.data.config, productMap);
    }

    if (['PHYSICAL_DAMAGE', 'PHYSICAL_DAMAGE_PLUS'].includes(event.selectReport) && sessionStorage.getItem('product') === 'AutoCheck Insurance') {
      this.props.actions.getPhysicalDamage(event.scoreModel, event.VIN, event.referenceNumber, new Date().toISOString(), event.selectReport, this.props.data.config, productMap);
    }

    if (['ALL_COVERAGE', 'ALL_COVERAGE_PLUS'].includes(event.selectReport) && sessionStorage.getItem('product') === 'AutoCheck Insurance') {
      this.props.actions.getAllCoverageScore(event.scoreModel, event.VIN, event.referenceNumber, new Date().toISOString(), event.selectReport, this.props.data.config, productMap);
    }

    if ((event.selectReport === 'VEHICLE_HISTORY' || event.selectReport === 'RISK_PLUS' || event.selectReport === 'PHYSICAL_DAMAGE_PLUS' || event.selectReport === 'ALL_COVERAGE_PLUS') && sessionStorage.getItem('product') === 'AutoCheck Insurance') {
      // 1B7KF26D7VJ581950
      const encodedReferenceNumber = event.referenceNumber && encodeURIComponent(event.referenceNumber);
      this.props.actions.getAutocheckVehicleHistory(event.VIN, encodedReferenceNumber, event.selectReport, this.props.data.config, productMap);
    }

    if (event.selectReport === 'NMVTIS') {
      // 1B7KF26D7VJ581950
      // get NMVTIS report
      this.props.actions.getAutocheckNMVTISReport(event.VIN, event.referenceNumber, this.props.data.config, productMap);
    }

    if (event.selectReport === 'RISK_SCORE' || event.selectReport === 'RISK_PLUS') {
      // get score report
      this.props.actions.getRiskPredictorScore(event.scoreModel, event.VIN, event.referenceNumber, new Date().toISOString(), event.selectReport, this.props.data.config, productMap);
    }

    if (event.selectReport === 'MILEAGE') {
      // get mileage report
      this.props.actions.getMileageReport(event.VIN, event.referenceNumber, this.props.data.config, productMap);
    }

    if (sessionStorage.getItem('product') === 'AutoCheck Auctions' && !experianHtmlReports.includes(event.selectReport)) {
      this.props.actions.getACAReport(event.VIN, event.selectReport, this.props.data.config, productMap);
    }
  };

  hideModal() {
    this.setState({ open: false });
    this.props.dispatch(reset('RunReportUserForm'));
    this.props.actions.clearRiskPredictorScore();
    this.props.actions.clearAllCoverageScore();
    this.props.actions.clearAutocheckVehicleHistory();
    this.props.actions.clearAutocheckNMVTISReport();
    this.props.actions.clearACAReport();
    this.props.actions.clearMileageReport();
    this.props.actions.clearPhysicalDamage();
  }

  handleReportChange = (event) => {
    if (event.target.value === 'VEHICLE_HISTORY') {
      this.props.dispatch(change('RunReportUserForm', 'scoreModel', ''));
    }
  };

  closeSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ snackbarOpen: false, snackbarMessage: '' });
  };

  render() {
    selectedProduct = sessionStorage.getItem('product');
    const { classes, handleSubmit, selectReport } = this.props;
    let ReportsToRun;
    const products = { 'AutoCheck Auctions': 'ACA', 'AutoCheck Insurance': 'ACI', 'VIN Cross Check': 'VXC' };
    const reportMenuOptions = [];
    const scoreModelMenuOptions = [];

    const locationId = localStorage.getItem('locationId');
    const location = this.props.data.person.locations.find(l => l.locationId === locationId);
    const { customerId } = location;

    if (this.props.data.reportTypes && this.props.data.reportTypes.reportTypes && this.props.data.reportTypes.reportTypes.reportTypes) {
      const reportTypeValues = this.props.data.reportTypes.reportTypes.reportTypes.sort((a, b) => {
        if (a.displayName.toLowerCase() > b.displayName.toLowerCase()) {
          return 1;
        }
        if (a.displayName.toLowerCase() < b.displayName.toLowerCase()) {
          return -1;
        }
        return 0;
      });
      reportTypeValues.forEach((rep) => {
        if (rep.availableForUi) {
          this.state.custReportData.forEach((custRep) => {
            if (custRep === rep.methodId && rep.productType.includes(products[sessionStorage.getItem('product')]) && (rep.methodId === '/nmvtis-report' || rep.methodId === '/vehicle/history/full' ||
              rep.methodId === '/vehicle/announcement')) {
              if (this.state.sharedReportAllowance) {
                let allowedReportsData = [];
                if (!Array.isArray(this.state.sharedReportAllowance)) {
                  allowedReportsData = Object.entries(this.state.sharedReportAllowance).map(e => ({ [e[0]]: e[1] }));
                } else {
                  allowedReportsData = this.state.sharedReportAllowance;
                }
                allowedReportsData.forEach((allowed) => {
                  if (Object.keys(allowed)[0] === ProductMap[sessionStorage.product]) {
                    allowed[Object.keys(allowed)].forEach((all) => {
                      if (all.includes(rep.methodId)) {
                        reportMenuOptions.push(<MenuItem key={rep.enum} value={rep.enum}>{rep.displayName}</MenuItem>);
                      }
                    });
                  }
                });
              }
            }
            else if (custRep === rep.methodId && rep.productType.includes(products[sessionStorage.getItem('product')])
              && rep.enum !== 'SUMMARY' && rep.enum !== 'DATA_EXISTS' && rep.enum !== 'FIRST_LAST') {
              reportMenuOptions.push(<MenuItem key={rep.enum} value={rep.enum}>{rep.displayName}</MenuItem>);
            }
          });
        }
      });

      this.props.data.reportTypes.reportTypes.scoreModel.forEach((scoreModel) => {
        scoreModelMenuOptions.push(<MenuItem key={scoreModel} value={scoreModel}>{scoreModel}</MenuItem>);
      });

      if (reportMenuOptions.length === 1) {
        this.props.change('selectReport', reportMenuOptions[0].key);
      }
    }

    ReportsToRun = (
      <Field name="selectReport" component={renderSelectField} label="Select a Report" className={classes.textField} divClassName={classes.formControl} onChange={this.handleReportChange}>
        {reportMenuOptions.length > 0 ? reportMenuOptions : <MenuItem value="-1">Loading... Please wait</MenuItem>}
      </Field>
    );

    return (
      <Layout className="App" showMenu menuTitle="Account Settings" leftTitle="Report Manager" rightTitle="Submit File" toolTip="Having problems? Please review the information you have entered to be sure everything is correct.  If you continue to have problems please contact our Customer Service department at (205) 414-2727." >
        <Paper className={classes.paperStyle}>
          <Form id="run_report_form" autoComplete="off" onSubmit={handleSubmit(this.handleSave)}>
            <Field
              normalize={upper}
              name="VIN"
              className={classes.textField}
              divClassName={classes.formControl}
              component={renderTextField}
              label="*VIN"
              style={{ marginTop: '8px !important' }}
            />
            {ReportsToRun}
            {(selectReport && (selectReport === 'RISK_SCORE' || selectReport === 'RISK_PLUS')) &&
              <Field name="scoreModel" component={renderSelectField} label="*Score Model" className={classes.textField} divClassName={classes.formControl} >
                {scoreModelMenuOptions}
              </Field>
            }
            {
              selectedProduct === 'AutoCheck Insurance' && !this.props.data.config.progressiveCustomerId.includes(customerId) && !this.props.data.config.ssoTestCustomer.includes(customerId) &&
              <Field name="referenceNumber" component={renderTextField} label="Reference Number" className={classes.textField} style={{ margin: 8 }} />
            }
            {
              // If the user is a progressive user, then we are going to run it against a normalize reference number function to
              // validate the number of characters inputted into the field
              selectedProduct === 'AutoCheck Insurance' && (this.props.data.config.progressiveCustomerId.includes(customerId) || this.props.data.config.ssoTestCustomer.includes(customerId)) && (selectReport && (selectReport === 'VEHICLE_HISTORY' || selectReport === 'RISK_PLUS')) &&
              <Field
                name="referenceNumber"
                component={renderTextField}
                label="Reference Number"
                normalize={normalizeReferenceNumber}
                className={classes.textField}
                divClassName={classes.marginStyle}
              />
            }
            <RenderDialog
              open={this.state.open}
              title=""
              message="The Submitted VIN seems to be invalid. Please check your VIN and try again"
              onClose={this.handleClose}
              className={classes.alertClass}
            />
            <div className={classes.buttonStyle}>
              <Button variant="raised"
                className={classes.buttonSize}
                disabled={!this.props.valid}
                style={(this.props.valid) ? { background: '#002053' } : { background: '#ddd' }}
                type="submit">Submit</Button>
              <div className={`${classes.messageStyle} mandatory-msg`}>* Required fields</div>
            </div>
            <PostFrame
              nmvtisReport={this.props.data.nmvtisReport}
              historyReport={this.props.data.historyReport}
              scoreReport={this.props.data.riskReport}
              acaReport={this.props.data.acaReport}
              mileageReport={this.props.data.mileageReport}
              physicalDamage={this.props.data.physicalDamage}
              allCoverage={this.props.data.allCoverage}
              displayDialog={this.state.open}
              hideModal={o => this.hideModal()}
              showSummary={this.state.showSummary}
              selectedReportType={this.state.selectedReportType}
            />
          </Form>
        </Paper>
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          open={this.state.snackbarOpen}
          autoHideDuration={5000}
          onClose={this.closeSnackbar}
        >
          <SnackbarContent
            className={classes.snackbarContent}
            message={
              <span className={classes.snackbarMessage}>
                <ErrorIcon className={classes.snackbarIcon} />
                {this.state.snackbarMessage}
              </span>
            }
            action={
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                className={classes.snackbarClose}
                onClick={this.closeSnackbar}
              >
                <CloseIcon />
              </IconButton>
            }
          />
        </Snackbar>
      </Layout>
    );
  }
}

RunReport.propTypes = {
  classes: PropTypes.shape().isRequired
};


const mapStateToProps = state => ({
  data: {
    person: state.person.person,
    login: state.login.login,
    historyReport: state.autocheckVehicleHistoryReport,
    nmvtisReport: state.autocheckNMVTISReport,
    config: state.config.config,
    physicalDamage: state.physicalDamageReport,
    allCoverage: state.allCoverageScoreReport,
    riskReport: state.riskPredictorScoreReport,
    reportTypes: state.reportTypes,
    acaReport: state.acaReport,
    mileageReport: state.mileageReport
  }
});

const mapDispatchToProps = dispatch => ({
  actions: {
    getAllCoverageScore: (model, VIN, referenceNumber, endDate, report, config, productMap) => {
      const product = sessionStorage.getItem('product');
      dispatch(getAllCoverageScore(model, VIN, referenceNumber, endDate, report, productMap[product], config));
    },
    getAutocheckVehicleHistory: (VIN, referenceNumber, report, config, productMap) => {
      const product = sessionStorage.getItem('product');
      dispatch(getAutocheckVehicleHistory(VIN, referenceNumber, productMap[product], report, config));
    },
    getAutocheckNMVTISReport: (VIN, referenceNumber, config, productMap) => {
      const product = sessionStorage.getItem('product');
      dispatch(getAutocheckNMVTISReport(VIN, referenceNumber, productMap[product], config));
    },
    getRiskPredictorScore: (model, VIN, referenceNumber, endDate, report, config, productMap) => {
      const product = sessionStorage.getItem('product');
      dispatch(getRiskPredictorScore(model, VIN, referenceNumber, endDate, report, productMap[product], config));
    },
    getPhysicalDamage: (model, VIN, referenceNumber, endDate, report, config, productMap) => {
      const product = sessionStorage.getItem('product');
      dispatch(getPhysicalDamage(model, VIN, referenceNumber, endDate, report, productMap[product], config));
    },
    getMileageReport: (VIN, referenceNumber, config, productMap) => {
      const product = sessionStorage.getItem('product');
      dispatch(getAutocheckMileageReport(VIN, referenceNumber, productMap[product], config));
    },
    clearAllCoverageScore: () => {
      dispatch(clearAllCoverageScore());
    },
    clearMileageReport: () => {
      dispatch(clearAutocheckMileageReport());
    },
    clearRiskPredictorScore: () => {
      dispatch(clearRiskPredictorScore());
    },
    clearAutocheckNMVTISReport: () => {
      dispatch(clearAutocheckNMVTISReport());
    },
    clearPhysicalDamage: () => {
      dispatch(clearPhysicalDamage());
    },
    clearAutocheckVehicleHistory: () => {
      dispatch(clearAutocheckVehicleHistory());
    },
    getReportTypes: (config) => {
      dispatch(getReportTypes(config));
    },
    custReportData: async (config, self) => {
      self.setState({ fetching: true });

      // get location record for the selected location (need location to get customer record)
      const locationId = localStorage.getItem('locationId');
      const locationResult = await dispatch(searchByAttribute('locations', 0, 'locationId', locationId, config));
      const location = optional(locationResult, ['value', 'data', 'items', 0], undefined);

      // get customer record for the selected location
      const { customerId } = location;
      const customerResult = await dispatch(searchByAttribute('customers', 0, 'customerId', customerId, config));
      const customer = optional(customerResult, ['value', 'data', 'items', 0], undefined);

      // update state
      self.setState({
        custReportData: customer.authorizedMethodIds,
        showSummary: customer.summary ? customer.summary : 'No',
        fetching: false,
        sharedReportAllowance: customer.sharedReportAllowance
      });
    },
    getAccidentReport: (VIN, reportType, config) => {
      dispatch(getACAReport(VIN, reportType, config));
    },
    getDiscrepancyReport: (VIN, reportType, config) => {
      dispatch(getACAReport(VIN, reportType, config));
    },
    getACAReport: (VIN, reportType, config) => {
      dispatch(getACAReport(VIN, reportType, config));
    },
    clearACAReport: () => {
      dispatch(clearACAReport());
    }
  }
});

let ConnectedRunReport = connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({ form: 'RunReportUserForm', validate, enableReinitialize: true })(RunReport));

// Decorate with connect to read form values
const selector = formValueSelector('RunReportUserForm'); // <-- same as form name
ConnectedRunReport = connect((state) => {
  // can select values individually
  const selectReport = selector(state, 'selectReport');
  return {
    selectReport
  };
})(ConnectedRunReport);

export default withStyles(styles, { withTheme: true })(ConnectedRunReport);


// WEBPACK FOOTER //
// ./src/components/Account/RunReport.js